import { authState as _authState } from '@dice-driven/d3-kit';

// Re-export authState. Apps call authState.init({ ..., appName: 'd3assets' })
// to prefix localStorage keys. The appName is set in assets-app.js init call.
export const authState = _authState;
